import isEqual from "lodash/isEqual";

/** Returns an object containing only the keys from `updated` whose values differ from `original`. */
export function createPatch<T extends Record<string, unknown>>(
  updated: T,
  original: Record<string, unknown>,
): Partial<T> {
  const patch: Partial<T> = {};
  for (const key of Object.keys(updated) as (keyof T)[]) {
    if (!isEqual(updated[key], original[key as string])) {
      patch[key] = updated[key];
    }
  }
  return patch;
}
